import { render, staticRenderFns } from "./weChatAddress.vue?vue&type=template&id=ee7af148&scoped=true&"
import script from "./weChatAddress.vue?vue&type=script&lang=js&"
export * from "./weChatAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7af148",
  null
  
)

export default component.exports